import _extends from "@babel/runtime-corejs2/helpers/extends";
import * as React from 'react';
import CommonChrome from '../CommonChrome';
export var Top = function Top(props) {
  return /*#__PURE__*/React.createElement(CommonChrome.Nav, _extends({
    horizontal: true
  }, props));
};
export default Top;